export const TOP_BAR_LOCATORS = {
  back: "TopBarLocators.back",
}
